
/**
 * This enum handle smart component skill format
 */
export enum SkillFormat {
  TEXT = 1,
  ADDRESS = 2,
  BOOLEAN = 3,
  NUMBER = 4,
  SCENARIO = 5
}